/**
 * PR-D4-035 — Google Sign-In landing (GIS via @react-oauth/google).
 * Replaces open-access CTA with official Google Identity button.
 */
// @ts-nocheck
import { useCallback, useState } from 'react';
import { GoogleLogin } from '@react-oauth/google';
import './LoginLanding.css';

const AUTH_TOKEN_KEY = 'sat_auth_token';
const AUTH_USER_KEY = 'sat_user';

export default function LoginLanding({ onSuccess }) {
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  const handleGoogleSuccess = useCallback(
    async (response) => {
      const credential = response?.credential;
      if (!credential) {
        setError('Не удалось получить токен Google. Попробуйте ещё раз.');
        return;
      }

      setBusy(true);
      setError('');

      try {
        const res = await fetch('/api/auth/google', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ credential }),
        });

        const body = await res.json().catch(() => ({}));

        if (!res.ok || !body?.success || !body?.token || !body?.user) {
          throw new Error(body?.error || `Ошибка входа (HTTP ${res.status})`);
        }

        try {
          localStorage.setItem(AUTH_TOKEN_KEY, body.token);
          localStorage.setItem(AUTH_USER_KEY, JSON.stringify(body.user));
        } catch {
          // non-fatal: navigation still proceeds
        }

        if (onSuccess) {
          onSuccess(body.user);
        }
      } catch (err) {
        setError(err instanceof Error ? err.message : 'Не удалось войти через Google');
      } finally {
        setBusy(false);
      }
    },
    [onSuccess],
  );

  const handleGoogleError = useCallback(() => {
    setError('Вход через Google отменён или недоступен. Попробуйте ещё раз.');
  }, []);

  return (
    <div className="login-container">
      <div className="login-sidebar">
        <div className="login-sidebar-content">
          <div className="login-logo-badge">EdTech Elite</div>
          <h1 className="login-sidebar-title">
            SAT Prep Simulator
            <span className="login-sidebar-subtitle">Math, Reading & Writing</span>
          </h1>
          <p className="login-sidebar-text">
            Умная платформа для подготовки к SAT. Адаптивные тесты, детальная аналитика и база из
            более чем 3700 актуальных вопросов. Начните свой путь к 1600 баллам уже сегодня.
          </p>
          <div className="login-sidebar-footer">
            © 2026 {import.meta.env.VITE_APP_NAME || 'SAT Prep Simulator'}. Все права защищены.<br />
            Support: {import.meta.env.VITE_SUPPORT_EMAIL || 'admin@sat1600.pro'}
          </div>
        </div>
      </div>

      <div className="login-main">
        <div className="login-card">
          <div className="login-card-header">
            <h2 className="login-card-title">Добро пожаловать</h2>
            <p className="login-card-subtitle">Войдите через Google, чтобы начать подготовку к SAT</p>
          </div>

          <div className="google-login-container" aria-busy={busy ? 'true' : 'false'}>
            <GoogleLogin
              onSuccess={handleGoogleSuccess}
              onError={handleGoogleError}
              useOneTap={false}
              theme="outline"
              size="large"
              text="signin_with"
              shape="rectangular"
              width="320"
            />
          </div>

          {error ? (
            <p className="login-auth-error" role="alert">
              {error}
            </p>
          ) : null}

          <div className="login-card-footer">
            Возникли проблемы с доступом? Обратитесь к администратору:{' '}
            {import.meta.env.VITE_SUPPORT_EMAIL || 'admin@sat1600.pro'}
          </div>
        </div>
      </div>
    </div>
  );
}
